import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import PreviewElement from './PreviewElement';
import PreviewIcon from './PreviewIcon';
import { HoverColor } from '../../../widgets/index';
import Style from 'style-it';

class CarouselPreview extends Component {
    render() {
        return (
            <Style>
                {`
          .CarouselPreview {
            font-family: ${this.props.global.font.main};
            font-size: ${this.props.global.font.baseSize};
          }
          .CarouselPreview * {
              color: ${this.props.gallery.text.color};
           }
          .CarouselPreview h2 {
            font-family: ${this.props.global.font.secondary};
          }
          .CarouselPreview h2, .CarouselPreview caption {
            background: ${this.props.gallery.text.background};
          }
        `}
                <div className="CarouselPreview" style={{ background: this.props.gallery.overlay.background }}>
                    <div className="row">
                        <h2 className="col">
                            Royal Suite Interior 1
                            <div className="close-icon">
                                <HoverColor color={this.props.closeIcon.hoverColor} />
                                <PreviewIcon
                                    fontData={this.props.gallery.text.color}
                                    className="col-lg-1 col-xs-12 col-sm-2 "
                                    icon="spark-icon-close spark-icon--md"
                                />
                            </div>
                        </h2>
                    </div>
                    <div className="row">
                        <div
                            className="col-xs-12 carousel-image handle"
                            style={{ backgroundImage: 'url(../../../../public/images/blank.jpg)' }}
                        ></div>
                    </div>
                    <div
                        className="row carousel-close-icon-row"
                        style={{
                            background: this.props.gallery.text.background,
                            color: this.props.gallery.text.color
                        }}
                    >
                        <div className="col-lg-5" />
                        <div className="col-lg-2 col-xs-12 col-sm-8 caption">Royal Suite Interior 1</div>
                    </div>
                </div>
            </Style>
        );
    }
}

CarouselPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object
};

const mapStateToProps = state => {
    return {
        ...state.app.data.theme.carousel,
        ...state.theme.carousel,
        global: state.app.data.theme.global
    };
};

export default connect(mapStateToProps)(CarouselPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/Preview.js